import { render, staticRenderFns } from "./NewFileDialog.vue?vue&type=template&id=4393c393"
import script from "./NewFileDialog.vue?vue&type=script&lang=ts"
export * from "./NewFileDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports